<mat-form-field appearance="outline" [ngClass]="class">
    <mat-label>{{ label }}</mat-label>
    <span matPrefix>
        <span [ngClass]="['material-symbols-outlined', 'wildcard-star', textSearchPattern.IsWildPrefix ? 'is-wild' : '']" (click)="toggleWildcardPrefix()" matTooltip="Wildcard prefix is {{ this.textSearchPattern!.IsWildPrefix ? 'on' : 'off' }}">
            star
        </span>
    </span>
    <input matInput name="input" placeholder="{{ placeholder }}" [(ngModel)]="textSearchPattern!.SearchString" />
    <span matSuffix>
        <span [ngClass]="['material-symbols-outlined', 'wildcard-star', textSearchPattern.IsWildSuffix ? 'is-wild' : '']" (click)="toggleWildcardSuffix()" matTooltip="Wildcard suffix is {{ this.textSearchPattern!.IsWildSuffix ? 'on' : 'off' }}">
            star
        </span>
    </span>
</mat-form-field>
